module.exports = __webpack_public_path__ + "assets/img/G2.a103a94b.png";